module.exports = __webpack_public_path__ + "static/media/PSDM_1.c6bbc679.gif";